<!-- 活动-立即报名 -->
<template>
	<div class="wrap">

		<div class="header-wrap" ref="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
			</div>
		</div>

		<div class="head">
			<p class="head-title">TDZ中的内存映射</p>
			<p class="head-row">
				<span class="head-tag">原创</span>
				艾克深科技 搞一下电子汽车
			</p>
			<p class="head-time">2022-03-04 22:33</p>
			<div class="head-box">
				<div class="head-column">
					<p class="font-1">收录于话题</p>
					<p class="font-2">#搞一下TDZ</p>
				</div>
				<p class="back-row">
					5个
					<img src="../assets/back-icon4.png">
				</p>
			</div>
		</div>

		<div class="content-box">
			<img src="../assets/img.png" class="img">
		</div>

		<div class="footer">
			<div class="footer-wrap">
				<ul class="footer-list">
					<li>
						<img src="../assets/shou-active.png" class="footer-icon" v-if="is_like == 1">
						<img src="../assets/shou.png" class="footer-icon" v-else>
						<span class="blue" v-if="is_like == 1">3632</span>
						<span class="gray" v-else>3632</span>
					</li>
					<li>
						<img src="../assets/xing-active.png" class="footer-icon" v-if="is_collect == 1">
						<img src="../assets/xing.png" class="footer-icon" v-else>
						<span class="blue" v-if="is_collect == 1">3632</span>
						<span class="gray" v-else>3632</span>
					</li>
					<li>
						<img src="../assets/icon-29.png" class="footer-icon">
						3632
					</li>
				</ul>
				<button type="button" class="footer-btn"    @click="$router.push('/activity-sign-up-information')">立即报名</button>
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				is_like: 1,
				is_collect:1
			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 44px 0 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 44px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	/* 新增 */
	.head {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 9px 14px 20px;
		box-sizing: border-box;
	}

	.head-title {
		width: 100%;
		color: #222222;
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 7px;
	}

	.head-time {
		width: 100%;
		color: #999999;
		font-size: 13px;
		margin-top: 7px;
	}

	.head-row {
		width: 100%;
		color: #636789;
		font-size: 14px;
	}

	.head-tag {
		display: inline-block;
		font-size: 10px;
		color: #AEAEAE;
		padding: 0 4px;
		background-color: #F1F1F1;
		border-radius: 2px;
		height: 18px;
		line-height: 18px;
		margin-right: 8px;
		vertical-align: middle;
	}

	.head-box {
		width: 100%;
		background-color: #F7F7F7;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 10px;
		padding: 12px 14px;
		box-sizing: border-box;
		margin-top: 18px;
	}

	.head-column {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.back-row {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.back-row>img {
		width: 10px;
	}

	.font-1 {
		color: #999999;
		font-size: 13px;
	}

	.font-2 {
		color: #636789;
		font-size: 14px;
		margin-top: 4px;
	}

	.jump-video {
		width: 92px;
		height: 28px;
		line-height: 28px;
		background-color: #2A63F3;
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 14px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}



	.footer {
		width: 100%;
		height: 83px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 6px 15px 0 0;
		box-sizing: border-box;
	}

	.footer-wrap {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-list {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 20px;
	}

	.footer-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #222222;
		font-size: 10px;
	}

	.footer-icon {
		height: 18px;
		margin-bottom: 4px;
	}

	.footer-btn {
		width: 135px;
		height: 36px;
		line-height: 36px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		color: #FFFFFF;
		background-color: #2A63F3;
		border-radius: 50px;
	}

	.content-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.img {
		width: 100%;
	}
	
	.blue {
		color: #2A63F3;
		font-size: 10px;
	}
	
	.gray {
		font-size: 10px;
		color: #333333;
	}
</style>
